var _path, _path2, _path3, _path4, _path5, _path6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoadmapGame(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 45,
    viewBox: "0 0 50 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2262 0.685577L2.08459 13.3483C1.77845 13.6224 1.93874 14.2102 2.31963 14.2102H48.1189C48.4998 14.2102 48.6601 13.6224 48.3539 13.3483L34.2123 0.685577C34.1443 0.624671 34.0619 0.591797 33.9773 0.591797H16.4612C16.3766 0.591797 16.2942 0.624671 16.2262 0.685577Z",
    fill: "url(#paint0_linear_1182_22210)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5231 1.281L2.7804 13.5216H47.6585L33.9158 1.281H16.5231ZM15.9263 0.218816C16.0858 0.0767038 16.2791 0 16.4776 0H33.9613C34.1599 0 34.3531 0.0767059 34.5127 0.218812L34.1959 0.733611L34.5127 0.218816L48.6282 12.7916C49.3463 13.4312 48.9704 14.8026 48.0769 14.8026H2.36201C1.46856 14.8026 1.09259 13.4312 1.81069 12.7916L15.9263 0.218816Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1789 44.2609L2.03356 15.0139C1.79419 14.7115 1.9722 14.2109 2.31914 14.2109H48.6098C48.9568 14.2109 49.1348 14.7115 48.8954 15.0139L37.4977 29.4164L25.7501 44.2609C25.5946 44.4574 25.3343 44.4574 25.1789 44.2609Z",
    fill: "url(#paint1_linear_1182_22210)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.20522 14.8981L25.2197 43.6472L48.2341 14.8981H2.20522ZM1.20338 15.5003C0.636148 14.7917 1.05798 13.6191 1.88014 13.6191H48.5592C49.3813 13.6191 49.8032 14.7917 49.2359 15.5003L25.8964 44.6555C25.528 45.1157 24.9113 45.1157 24.5429 44.6555L1.20338 15.5003Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9445 0L16.9408 0.447627L12.894 13.8433L25.9559 43.7999L25.0184 44.4079L11.7334 13.9395L15.9445 0Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.8409 0L33.8103 0.447627L37.9967 13.8433L24.4844 43.7999L25.4541 44.4079L39.1973 13.9395L34.8409 0Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1182_22210",
    x1: 25.2192,
    y1: 0.591797,
    x2: 25.2192,
    y2: 14.2102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1182_22210",
    x1: 25.4645,
    y1: 14.2109,
    x2: 25.4645,
    y2: 44.6218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBF2C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEECB5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmapGame);
export default __webpack_public_path__ + "static/media/roadmap_game.16d13a78c0eb7db9360fc6a40759dc22.svg";
export { ForwardRef as ReactComponent };